import React from "react"

import { GatsbyImage, getImage, withArtDirection } from "gatsby-plugin-image"

import { useMockableImageQuery } from "../../queries/useMockableImagesQuery"
export default ({
  image,
  classNameImage = "",
  containerClassName = "",
  imageHeight = null,
  loading = null,
  imageAltText = "image text",
}) => {
  const data = useMockableImageQuery()

  var dataToShow = data.allFile.edges.filter(file => file.xl.base === image)

  if (dataToShow.length > 0) {
    const images = withArtDirection(getImage(dataToShow[0].xxl), [
      {
        media: "(max-width: 1440px)",
        image: getImage(dataToShow[0].xl),
      },
      {
        media: "(max-width: 1280px)",
        image: getImage(dataToShow[0].lg),
      },
      {
        media: "(max-width: 768px)",
        image: getImage(dataToShow[0].md),
      },
      {
        media: "(max-width: 480px)",
        image: getImage(dataToShow[0].sm),
      },
    ])
    return (
      <GatsbyImage
        className={`${classNameImage} ${containerClassName}`}
        style={{ width: "100%", height: imageHeight || "inherit" }}
        image={getImage(images)}
        loading={loading ? loading : "lazy"}
        alt={imageAltText}
      />
    )
  } else {
    return <></>
  }
}
